import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'react-datepicker/dist/react-datepicker.css';
//import 'drag-drop-touch-polyfill/DragDropTouch.js'

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
